export interface Period {
	id: 'DAILY' | 'WEEKLY' | 'MONTHLY' | undefined;
	name: string;
}

export enum SortType {
	CURRICULUM = 'curriculum',
	COMPLETION = 'completion',
	SUCCESS_RATE = 'successRate'
}

export interface SortState {
	field: SortType | null;
	direction: 'asc' | 'desc';
}
